"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
var _lodash = _interopRequireDefault(require("lodash"));
var _vue = _interopRequireDefault(require("vue"));
var _json = _interopRequireDefault(require("json5"));
var _i18next = _interopRequireDefault(require("i18next"));
var _i18nextHttpBackend = _interopRequireDefault(require("i18next-http-backend"));
var _vueI18next = _interopRequireDefault(require("@panter/vue-i18next"));
var _vueVirtualScroller = _interopRequireDefault(require("vue-virtual-scroller"));
require("vue-virtual-scroller/dist/vue-virtual-scroller.css");
require("whatwg-fetch");
require("intersection-observer");
var _App = _interopRequireDefault(require("@/components/App"));
var _StartupError = _interopRequireDefault(require("@/components/StartupError"));
var _Welcome = _interopRequireDefault(require("@/components/startups/Welcome"));
var _ZncLogin = _interopRequireDefault(require("@/components/startups/ZncLogin"));
var _CustomServer = _interopRequireDefault(require("@/components/startups/CustomServer"));
var _KiwiBnc = _interopRequireDefault(require("@/components/startups/KiwiBnc"));
var _Personal = _interopRequireDefault(require("@/components/startups/Personal"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var _ConfigLoader = _interopRequireDefault(require("@/libs/ConfigLoader"));
var _state = _interopRequireDefault(require("@/libs/state"));
var _ThemeManager = _interopRequireDefault(require("@/libs/ThemeManager"));
var _InputHandler = _interopRequireDefault(require("@/libs/InputHandler"));
var _StatePersistence = _interopRequireDefault(require("@/libs/StatePersistence"));
var Storage = _interopRequireWildcard(require("@/libs/storage/Local"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _AudioManager = require("@/libs/AudioManager");
var _SoundBleep = require("@/libs/SoundBleep");
var _WindowTitle = _interopRequireDefault(require("@/libs/WindowTitle"));
var _configTemplates = require("@/res/configTemplates");
var _available = _interopRequireDefault(require("@/res/locales/available.json"));
var _enUs = _interopRequireDefault(require("@/../static/locales/en-us.json"));
require("@/components/utils/TabbedView");
require("@/components/utils/InputText");
require("@/components/utils/IrcInput");
require("@/components/utils/InputPrompt");
require("@/components/utils/InputConfirm");
require("@/components/utils/TransitionExpand");
require("@/thirdparty/");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// fetch polyfill

// polyfill for vue-virtual-scroller & ie11

// Global utilities

_vue.default.use(_vueVirtualScroller.default);
let logLevelMatch = window.location.href.match(/kiwi-loglevel=(\d)/);
if (logLevelMatch && logLevelMatch[1]) {
  let newLevel = parseInt(logLevelMatch[1], 10);
  _Logger.default.setLevel(newLevel);
  (0, _Logger.default)('Logging level set to', newLevel);
}
let log = _Logger.default.namespace('main');

// Add the global API as soon as possible so that things can start listening to it
let api = window.kiwi = _GlobalApi.default.singleton();

// Third party imports now have access to the state and api
/* eslint-disable import/first */

function getQueryVariable(variable) {
  let query = window.location.search.substring(1);
  let vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}

// Add a handy this.listen() fn to Vue instances. Saves on the need to add an event listener
// and then manually remove them all the time.
_vue.default.mixin({
  beforeDestroy: function beforeDestroy() {
    (this.listeningEvents || []).forEach(fn => fn());
  },
  methods: {
    listen: function listen(source, event, fn) {
      this.listeningEvents = this.listeningEvents || [];
      let off = () => {
        (source.removeEventListener || source.$off || source.off).call(source, event, fn);
      };
      this.listeningEvents.push(off);
      (source.addEventListener || source.$on || source.on).call(source, event, fn);
      return off;
    },
    listenOnce: function listenOnce(source, event, _fn) {
      let fn = _fn;
      this.listeningEvents = this.listeningEvents || [];
      let off = () => {
        (source.removeEventListener || source.$off || source.off).call(source, event, fn);
      };
      this.listeningEvents.push(off);
      if (source.addEventListener) {
        // Create our own once handler as the DOM doesn't support this itself
        fn = function onceFn(...args) {
          source.removeEventListener(event, onceFn);
          fn(...args);
        };
        source.addEventListener(event, fn);
      } else {
        (source.$once || source.once).call(source, event, fn);
      }
      return off;
    }
  }
});

// Timer functions that are auto cleaned up when a component is destroyed
_vue.default.mixin({
  beforeDestroy: function beforeDestroy() {
    (this.timerEvents || []).forEach(tmr => clearTimeout(tmr));
  },
  methods: {
    setInterval(...args) {
      this.timerEvents = this.timerEvents || [];
      let v = setInterval(...args);
      this.timerEvents.push(v);
      return v;
    },
    setTimeout(...args) {
      this.timerEvents = this.timerEvents || [];
      let v = setTimeout(...args);
      this.timerEvents.push(v);
      return v;
    },
    clearInterval(timerId) {
      return this.clearTimeout(timerId);
    },
    clearTimeout(timerId) {
      this.timerEvents = this.timerEvents || [];
      for (let idx = this.timerEvents.length - 1; idx >= 0; idx--) {
        if (this.timerEvents[idx] === timerId) {
          this.timerEvents.splice(idx, 1);
          clearTimeout(timerId);
          return true;
        }
      }
      return false;
    }
  }
});

// Make the state available to all components by default
_vue.default.mixin({
  computed: {
    $state() {
      return (0, _state.default)();
    }
  }
});

// Allow adding existing raw elements to component templates
// Eg: <div v-rawElement="domElement"></div>
// Eg: <div v-rawElement="{el: domElement, data:{foo:'bar'}}"></div>
_vue.default.directive('rawElement', {
  bind(el, binding) {
    if (binding.value.nodeName) {
      el.appendChild(binding.value);
    } else if (binding.value.el) {
      let rawEl = binding.value.el;
      el.appendChild(rawEl);

      // Add any data attributes to the raw element
      if (binding.value.data) {
        Object.keys(binding.value.data).forEach(key => {
          rawEl.dataset[key] = binding.value.data[key];
        });
      }

      // Add any properties to the raw element
      if (binding.value.props) {
        Object.keys(binding.value.props).forEach(key => {
          rawEl[key] = binding.value.props[key];
        });
      }
    }
  }
});

// Register a global custom directive called `v-focus`
_vue.default.directive('focus', {
  // Support conditional eg. v-focus="false"
  bind(el, bindings) {
    el.dataset.focus = bindings.value === undefined || !!bindings.value;
  },
  // When the bound element is inserted into the DOM...
  inserted(el) {
    // dataset properties are strings
    if (el.dataset.focus !== 'true') {
      return;
    }
    // Element is input so focus it
    if (el.tagName === 'INPUT') {
      el.focus();
      return;
    }
    // Try to focus the first input element
    let input = el.getElementsByTagName('input')[0];
    if (input) {
      input.focus();
    }
  }
});
let ROSymbol = Symbol('resizeobserver');
_vue.default.directive('resizeobserver', {
  bind(el, bindings) {
    let cb = bindings.value || function noop() {};
    el[ROSymbol] = new ResizeObserver(cb);
    el[ROSymbol].observe(el);
  },
  unbind(el) {
    el[ROSymbol].unobserve(el);
  }
});
loadApp();
function loadApp() {
  let configFile = 'static/config.json';
  let configObj = null;

  /**
   * Finding the config file
   * In order, looks in the following places:
   *   1. If a 'config' argument is in the query string, static/config_THEVALUE_.json
   *   2. If a window.kiwiConfig function exists, use it's return value as the config object.
   *   3. If a <meta name="kiwiconfig" content=""> is found, then the content becomes the config
   *      URL.
   *   4. If a <script name="kiwiconfig" type="application/json"></script> is found, then the
   *      content becomes the config JSON without making another web request.
   */
  if (getQueryVariable('config')) {
    configFile = 'static/config_' + getQueryVariable('config') + '.json';
  } else if (typeof window.kiwiConfig === 'function') {
    try {
      configObj = window.kiwiConfig();
    } catch (err) {
      log.error('Config file: ' + err.stack);
      showError();
    }
  } else if (document.querySelector('meta[name="kiwiconfig"]')) {
    configFile = document.querySelector('meta[name="kiwiconfig"]').content;
  } else if (document.querySelector('script[name="kiwiconfig"]')) {
    let configContents = document.querySelector('script[name="kiwiconfig"]').innerHTML;
    try {
      configObj = _json.default.parse(configContents);
    } catch (parseErr) {
      log.error('Config file: ' + parseErr.stack);
      showError();
    }
  }
  let configLoader = new _ConfigLoader.default();
  configLoader.addValueReplacement('protocol', window.location.protocol).addValueReplacement('wsprotocol', window.location.protocol === 'https:' ? 'wss:' : 'ws:').addValueReplacement('tls', window.location.protocol === 'https:').addValueReplacement('hostname', window.location.hostname).addValueReplacement('host', window.location.host).addValueReplacement('port', window.location.port || (window.location.protocol === 'https:' ? 443 : 80)).addValueReplacement('hash', (window.location.hash || '').substr(1)).addValueReplacement('query', (window.location.search || '').substr(1)).addValueReplacement('referrer', window.document.referrer);
  (configObj ? configLoader.loadFromObj(configObj) : configLoader.loadFromUrl(configFile)).then(applyConfig).then(initState).then(initInputCommands).then(initLocales).then(initThemes).then(loadPlugins).then(initSound).then(startApp).catch(showError);
}
function applyConfig(config) {
  Misc.dedotObject(config);
  // if we have a config template apply that before other configs
  if (_configTemplates.configTemplates[config.template]) {
    applyConfigObj(_configTemplates.configTemplates[config.template], (0, _state.default)().settings);
  }
  applyConfigObj(config, (0, _state.default)().settings);
}

// Recursively merge an object onto another via Vue.$set
function applyConfigObj(obj, target) {
  // Keys in the newObjects array will get new objects created (empty) before merging from config
  let newObjects = ['emojis', 'autocompleteTokens'];
  _lodash.default.each(obj, (val, key) => {
    if (typeof val === 'object') {
      if (
      // Key does not exist or is not the correct data type
      typeof target[key] !== 'object' ||
      // Key requires a new object/array before merging config data
      target === (0, _state.default)().settings && newObjects.includes(key)) {
        // Create the correct type of object
        let newVal = _lodash.default.isArray(val) ? [] : {};
        _vue.default.set(target, key, newVal);
      }
      applyConfigObj(val, target[key]);
    } else {
      _vue.default.set(target, key, val);
    }
  });
}
function loadPlugins() {
  return new Promise((resolve, reject) => {
    let plugins = (0, _state.default)().settings.plugins || [];
    let pluginIdx = -1;
    loadNextScript();
    function loadNextScript(sSrc, fOnload) {
      let plugin = plugins[++pluginIdx];
      if (!plugin) {
        resolve();
        return;
      }
      if (plugin.url.indexOf('.js') > -1) {
        // The plugin is a .js file so inject it as a script
        let scr = document.createElement('script');
        scr.onerror = () => {
          log.error(`Error loading plugin '${plugin.name}' from '${plugin.url}'`);
          loadNextScript();
        };
        scr.onload = () => {
          loadNextScript();
        };
        document.body.appendChild(scr);
        scr.src = plugin.url;
      } else {
        // Treat the plugin as a HTML document and just inject it into the document
        fetch(plugin.url).then(response => {
          if (!response.ok) {
            throw new Error(response.status + ' ' + response.statusText);
          }
          return response.text();
        }).then(pluginRaw => {
          let el = document.createElement('div');
          el.id = 'kiwi_plugin_' + plugin.name.replace(/[ "']/g, '');
          el.style.display = 'none';
          el.innerHTML = pluginRaw;

          // The browser won't execute any script elements so we need to extract them
          // and place them into the DOM using our own script elements
          let scripts = [...el.querySelectorAll('script')];

          // IE11 does not support nodes.forEach()
          scripts.forEach(limitedScr => {
            limitedScr.parentElement.removeChild(limitedScr);
            let scr = document.createElement('script');
            scr.text = limitedScr.text;
            el.appendChild(scr);
          });
          document.body.appendChild(el);
          loadNextScript();
        }).catch(() => {
          log.error(`Error loading plugin '${plugin.name}' from '${plugin.url}'`);
          loadNextScript();
        });
      }
    }
  });
}
function initLocales() {
  _vue.default.use(_vueI18next.default);
  _i18next.default.use(_i18nextHttpBackend.default);
  _i18next.default.init({
    supportedLngs: _available.default.locales,
    compatibilityJSON: 'v3',
    fallbackLng: 'en-us',
    lowerCaseLng: true,
    backend: {
      loadPath: (langs, namespaces) => {
        // If allowMultiLoading is false, langs and namespaces will have only one element
        const namespace = namespaces[0];
        return namespace === 'translation' ? 'static/locales/{{lng}}.json' : api.translationUrls[namespace];
      },
      // allow cross domain requests
      crossDomain: false,
      // allow credentials on cross domain requests
      withCredentials: false,
      // your backend server supports multiloading
      allowMultiLoading: false
    },
    interpolation: {
      // We let vuejs handle HTML output escaping
      escapeValue: false
    }
  });

  // Build in the english translation so it can be used as a fallback
  _i18next.default.addResourceBundle('en-us', 'translation', _enUs.default);

  // Make the translation services available via the global API
  api.i18n = _i18next.default;
  api.vueI18n = new _vueI18next.default(_i18next.default);

  // Override the $t function so that empty translations fallback to en-us
  _vue.default.mixin({
    computed: {
      $t() {
        return (key, options) => {
          const vueI18n = this.$i18n || api.vueI18n;
          let val = vueI18n.i18next.t(key, options, vueI18n.i18nLoadedAt);
          if (!val) {
            let opts = options || {};
            opts.lng = 'en-us';
            val = vueI18n.i18next.t(key, opts, vueI18n.i18nLoadedAt);
          }
          return val;
        };
      }
    }
  });
  const setDefaultLanguage = () => {
    let defaultLang = (0, _state.default)().setting('language');
    let preferredLangs = _lodash.default.clone(window.navigator && window.navigator.languages) || [];

    // our configs default lang overrides all others
    if (defaultLang) {
      preferredLangs.unshift(defaultLang);
    }

    // set a default language
    _i18next.default.changeLanguage('en-us');

    // Go through our browser languages until we find one that we support
    for (let idx = 0; idx < preferredLangs.length; idx++) {
      let lang = preferredLangs[idx];

      // if this is a language such as 'fr', add a following one of 'fr-fr' to cover
      // both cases
      if (lang.length === 2) {
        let altLangs = _available.default.locales.filter(l => l.startsWith(lang + '-'));
        preferredLangs.splice(idx + 1, 0, lang + '-' + lang, ...altLangs);
      }
      if (_lodash.default.includes(_available.default.locales, lang.toLowerCase())) {
        _i18next.default.changeLanguage(lang, (err, t) => {
          if (err) {
            // setting the language failed so set default again
            _i18next.default.changeLanguage('en-us');
          }
        });
        break;
      }
    }
  };
  setDefaultLanguage();

  // Update the language if the setting changes.
  (0, _state.default)().$watch('user_settings.language', lang => {
    if (!lang && !(0, _state.default)().setting('language')) {
      setDefaultLanguage();
    } else {
      _i18next.default.changeLanguage(lang || (0, _state.default)().setting('language') || 'en-us');
    }
  });
}
async function initState() {
  let stateKey = (0, _state.default)().settings.startupOptions.state_key;

  // Default to a preset key if it wasn't set
  if (typeof stateKey === 'undefined') {
    stateKey = 'kiwi-state';
  }
  let persistLog = _Logger.default.namespace('StatePersistence');
  let persist = new _StatePersistence.default(stateKey || '', (0, _state.default)(), Storage, persistLog);
  persist.includeBuffers = !!(0, _state.default)().settings.startupOptions.remember_buffers;
  if (stateKey) {
    await persist.loadStateIfExists();
  }
  api.setState((0, _state.default)());
}
function initThemes() {
  let argTheme = getQueryVariable('theme');
  let themeMgr = _ThemeManager.default.instance((0, _state.default)(), argTheme);
  api.setThemeManager(themeMgr);
}
function initSound() {
  let sound = new _SoundBleep.SoundBleep();
  let bleep = new _AudioManager.AudioManager(sound);
  bleep.listen((0, _state.default)());
  bleep.watchForMessages((0, _state.default)());
}
function initInputCommands() {
  /* eslint-disable no-new */
  new _InputHandler.default((0, _state.default)());
}
function startApp() {
  let state = (0, _state.default)();
  new _WindowTitle.default(state);
  api.emit('init');

  // Decide which startup screen to use depending on the config
  let startupScreens = {
    welcome: _Welcome.default,
    customServer: _CustomServer.default,
    kiwiBnc: _KiwiBnc.default,
    znc: _ZncLogin.default,
    personal: _Personal.default
  };
  let extraStartupScreens = state.getStartups();
  let startupName = state.getSetting('settings.startupScreen') || 'personal';
  let startup = extraStartupScreens[startupName] || startupScreens[startupName];
  if (!startup) {
    throw new Error(`Startup screen "${startupName}" does not exist`);
  }

  /* eslint-disable no-new */
  new _vue.default({
    el: '#app',
    render: h => h(_App.default, {
      props: {
        startupComponent: startup
      }
    }),
    i18n: api.vueI18n
  });
  api.emit('ready');
}
function showError(err) {
  if (err) {
    log.error('Error starting Kiwi IRC:', err);
  } else {
    log.error('Unknown error starting Kiwi IRC');
  }

  /* eslint-disable no-new */
  new _vue.default({
    el: '#app',
    render: h => h(_StartupError.default, {
      props: {
        error: err
      }
    })
  });
}